import { jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { useFormMeta } from "@workwave-tidal/form-fairy";
import { SuperCarIndicator } from "./SuperCarIndicator/index.js";
function FormValidationIndicator(props) {
  const {
    meta: { validating }
  } = useFormMeta();
  const [canBeShown, setCanBeShown] = useState(false);
  const rTimer = useRef(null);
  useEffect(() => {
    if (validating) {
      rTimer.current = setTimeout(() => {
        setCanBeShown(true);
      }, 500);
      return;
    }
    setCanBeShown(false);
    if (!rTimer.current) return;
    clearTimeout(rTimer.current);
    rTimer.current = null;
  }, [validating]);
  useEffect(
    () => () => {
      if (rTimer.current) {
        clearTimeout(rTimer.current);
      }
    },
    []
  );
  return canBeShown ? /* @__PURE__ */ jsx(SuperCarIndicator, { ...props }) : null;
}
export {
  FormValidationIndicator
};
//# sourceMappingURL=FormValidationIndicator.js.map
